import classnames from "classnames";
import { Row, Col, Button } from "reactstrap";
import { ModalOverlay, ModalBox } from "./ModalStyled";

const FormConfirmation = (props) => {
  return (
    <ModalOverlay className={classnames({ show: props.show })}>
      <ModalBox className="smBox">
        <h2 className="modal-title">Confirm Navigation</h2>
        <p className="sub-title">
          You have unsaved changes that will be lost if you decide to continue.
        </p>
        <p className="modal-text">Are you sure you want to leave this page?</p>
        <Row>
          <Col>
            <Button
              className="btn-gray"
              block
              onClick={() => props.confirm(false)}
            >
              Stay on this Page
            </Button>
          </Col>
          <Col>
            <Button
              className="btn-blue"
              block
              onClick={() => props.confirm(true)}
            >
              Leave this Page
            </Button>
          </Col>
        </Row>
      </ModalBox>
    </ModalOverlay>
  );
};

export default FormConfirmation;
